import { render, staticRenderFns } from "./zttlgz.vue?vue&type=template&id=315c9632&scoped=true"
import script from "./zttlgz.vue?vue&type=script&lang=js"
export * from "./zttlgz.vue?vue&type=script&lang=js"
import style0 from "./zttlgz.vue?vue&type=style&index=0&id=315c9632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c9632",
  null
  
)

export default component.exports